/* 
Object:         FirmwareAdministration
Description:    Logic and events for the module FirmwareAdministration
Used in:        FirmwareAdministration
*/

import { ModuleActionViewEnum } from "../enums/moduleActionViewEnum"

import * as appsettings         from "../appsettings"
import * as dialog              from "../dialog"
import * as navigation          from "../navigation"
import * as viewmode            from "../viewmode"

/**
 * Delete item from grid
 * @param {any} e
 */
export function deleteItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    const event = e;
    const data = this;

    function callbackYes(event: JQuery.Event & { currentTarget: HTMLElement }, data: kendo.ui.Grid) {

        // Prevent default behaviour 
        event.preventDefault();

        const dataItem = data.dataItem($(event.currentTarget).closest("tr")) as FirmwareGridVM;

        // Post Data
        $.ajax({
            type: "GET",
            url: appsettings.getUrl("FirmwareAdministration/Delete?firmwareId=" + dataItem.FirmwareID),
            success: function () {
                // Refresh datasource grid 
                $("#FirmwareAdministrationGrid").data("kendoGrid").dataSource.read();
            }
        });
    }

    function callingCallback() {
        callbackYes(event, data);
    }

    dialog.createDialog(callingCallback, function () { });
}

/**
 * Update a item from grid
 */
export function editItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    // Get DateItem
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as FirmwareGridVM;

    // Label
    const label = dataItem.Name;

    // Edit mode Form 
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("FirmwareAdministration/Edit?firmwareId=" + dataItem.FirmwareID + "&breadcrumbLabel=" + label);
}

/**
 * Show item from grid
 */
export function showItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    // Get DateItem 
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as FirmwareGridVM;

    // Label
    const label = dataItem.Name;

    // Show mode Form
    viewmode.setViewMode(ModuleActionViewEnum.Show);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("FirmwareAdministration/Show?firmwareId=" + dataItem.FirmwareID + "&breadcrumbLabel=" + label);
}

export function onSelectFirmware(e: kendo.ui.UploadSelectEvent): void {
    $.each(e.files, function (index, value) {
        readMultipleFiles_KendoUploadWidget(value, "#FirmwareData");
    });
}

export function readMultipleFiles_KendoUploadWidget(file: KendoUploadFileExtended, control: string): void {
    const reader = new FileReader();

    reader.onload = function (e: ProgressEvent<FileReader>) {
        //capture value in hidden field for 'future' post form moment.
        $(control).val(e.target.result as string);
    }

    reader.readAsDataURL(file.rawFile);
}
